import { defineMessages } from 'react-intl';

const messages = defineMessages({
  preview: {
    description: 'Preview Modal title',
    defaultMessage: 'Preview',
    id: 'wxwA/U',
  },
  desktop: {
    description: 'link to preview the desktop version of branded tracking email',
    defaultMessage: 'Desktop',
    id: '6k7AOx',
  },
  tablet: {
    description: 'link to preview the tablet version of branded tracking email',
    defaultMessage: 'Tablet',
    id: 'IxLT/t',
  },
  mobile: {
    description: 'link to preview the mobile version of branded tracking email',
    defaultMessage: 'Mobile',
    id: 'eBpkwO',
  },
});

export default messages;
